import { useStripeRedirect } from "@/components/Account/payment/useStripeRedirect";
import { Button, ButtonProps } from "@/ui/cva/Button";

type StripeAccountButtonProps = Omit<ButtonProps, "type"> & {
  type: "ACCOUNT_ONBOARDING" | "ACCOUNT_UPDATE";
};

/**
 * A button that opens Stripe's hosted flow. Used by the dashboard's open
 * action; the Payment settings page composes the same hook itself so it can
 * remember the status it left with.
 */
export const StripeAccountButton = ({
  type,
  ...props
}: StripeAccountButtonProps) => {
  const { redirect, redirecting } = useStripeRedirect();

  return (
    <Button
      type="button"
      loading={redirecting}
      onClick={() => void redirect(type)}
      {...props}
    />
  );
};
